import { BudgetInput } from '@/types/budget';
import { filterValueToQuery, camelObjectToSnakeObject } from '@/api';

export default function budget(axios: any) {
  async function getBudgets(filter: any) {
    try {
      const response = await axios.get(`/api/bom_costs?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/budget] getBudgets Error', e);
    }
    return null;
  }

  async function getBudget(id: number) {
    const response = await axios.get(`/api/bom_costs/${id}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/budget] updateBudget Error', e);
    }
    return null;
  }

  async function createBudget(payload: BudgetInput) {
    const response = await axios.post('/api/bom_costs', camelObjectToSnakeObject(payload, ['cost']));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/budget] createBudget Error', e);
    }
    return null;
  }

  async function updateBudget(id: number | string, payload: BudgetInput) {
    const response = await axios.put(`/api/bom_costs/${id}`, payload);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/budget] updateBudget Error', e);
    }
    return null;
  }

  async function deleteBudget(id: number) {
    const response = await axios.delete(`/api/bom_costs/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/budget] updateBudget Error', e);
    }
    return null;
  }

  return {
    getBudgets,
    getBudget,
    createBudget,
    updateBudget,
    deleteBudget,
  };
}
